export default {
  title: 'Flagi funkcji',
  subtitle: 'Włącz lub wyłącz funkcje platformy dla {{company}}.',
  no_company: 'Wybierz restaurację, aby zarządzać jej flagami funkcji.',
  columns: {
    feature: 'Funkcja',
    status: 'Status',
  },
  flags: {
    paypal_standalone: {
      name: 'PayPal (bezpośredni)',
      description:
        'Pozwól tej restauracji przyjmować płatności PayPal bezpośrednio na jej własne konto PayPal. Domyślnie włączone dla restauracji partnerów rozliczanych przez Foodamigos, gdzie opłata serwisowa klienta jest również pobierana od tych płatności, a udział platformy jest fakturowany na partnera.',
    },
    vip_free_flyers: {
      name: 'Miesięczne bezpłatne ulotki',
      description:
        'Automatycznie wysyłaj 500 ulotek promocyjnych miesięcznie do tej restauracji (domyślnie: włączone dla poziomu VIP i Star).',
    },
    custom_store_seo: {
      name: 'Własne SEO sklepu',
      description: 'Pozwól tej restauracji zarządzać ustawieniami SEO dla jej sklepu internetowego.',
    },
    external_printer: {
      name: 'Zewnętrzna drukarka paragonów',
      description:
        'Pozwól tej restauracji podłączyć sieciową drukarkę paragonów do aplikacji terminala, zamiast drukować na wbudowanej drukarce terminala.',
    },
    stripe_payment_element: {
      name: 'Płatność przez Stripe Payment Element',
      description:
        'Pozwól, aby własne konto Stripe restauracji decydowało, jakie metody płatności oferuje kasa. Włącz tę opcję dopiero gdy platforma Stripe ma skonfigurowane metody płatności dla kont połączonych.',
    },
  },
  toasts: {
    enabled: 'Funkcja włączona.',
    disabled: 'Funkcja wyłączona.',
    error: 'Nie udało się zaktualizować funkcji. Spróbuj ponownie.',
    load_error: 'Nie udało się załadować flag funkcji.',
  },
};
